import { render, staticRenderFns } from "./office-payroll-edit.vue?vue&type=template&id=17a91580&lang=pug"
import script from "./office-payroll-edit.vue?vue&type=script&lang=ts"
export * from "./office-payroll-edit.vue?vue&type=script&lang=ts"
import style0 from "./office-payroll-edit.vue?vue&type=style&index=0&id=17a91580&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports